import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Canonical tracker entry point. Sends visitors and crawlers to the existing
 * exam preparation page so there is a single indexable page per exam.
 */
export const Route = createFileRoute("/tracker/mht-cet")({
  beforeLoad: () => {
    throw redirect({ to: "/mht-cet", statusCode: 301 });
  },
});
